module.exports = __webpack_public_path__ + "img/adobe-12.6d4cc11a.png";